module.exports = __webpack_public_path__ + "img/refuse.95758fab.png";